import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Activity, Target } from "lucide-react";
import api from "../lib/api";
import { computeProximity } from "../lib/proximity";

export default function PortfolioStatsBar({ setups }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.portfolioSummary().then(setSummary).catch(() => {});
  }, [setups]);

  const inZoneCount = setups.filter(s => {
    const p = computeProximity(s);
    return p !== null && p <= 1.5;
  }).length;

  const activeCount = setups.filter(s => s.status !== "closed").length;

  const winRate = summary?.closed?.count > 0
    ? Math.round((summary.closed.winners / summary.closed.count) * 100)
    : null;

  const avgPnl = summary?.active?.avg_pnl_percent;

  const stats = [
    {
      label: "Aktive Setups",
      value: activeCount,
      icon: Activity,
      color: "text-zinc-300",
    },
    {
      label: "In / nahe Zone",
      value: inZoneCount,
      icon: Target,
      color: inZoneCount > 0 ? "text-emerald-400" : "text-zinc-500",
      highlight: inZoneCount > 0,
    },
    {
      label: "Ø P&L (offen)",
      value: avgPnl != null ? `${avgPnl > 0 ? "+" : ""}${avgPnl.toFixed(1)}%` : "—",
      icon: avgPnl != null && avgPnl >= 0 ? TrendingUp : TrendingDown,
      color: avgPnl == null ? "text-zinc-500" : avgPnl >= 0 ? "text-emerald-400" : "text-rose-400",
    },
    {
      label: "Win-Rate",
      value: winRate != null ? `${winRate}%` : "—",
      sub: summary?.closed?.count ? `${summary.closed.winners}W / ${summary.closed.losers}L` : null,
      icon: TrendingUp,
      color: winRate == null ? "text-zinc-500" : winRate >= 50 ? "text-emerald-400" : "text-rose-400",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-px border-b border-zinc-800 bg-zinc-800">
      {stats.map((s) => {
        const Icon = s.icon;
        return (
          <div
            key={s.label}
            className={`bg-zinc-950 px-4 py-3 flex items-center gap-3 ${s.highlight ? "bg-emerald-950/20" : ""}`}
          >
            <Icon size={16} className={`${s.color} shrink-0`} strokeWidth={1.75} />
            <div className="min-w-0">
              <div className={`font-display font-black text-xl leading-none ${s.color}`}>
                {s.value}
              </div>
              <div className="text-[10px] text-zinc-500 uppercase tracking-widest font-display mt-0.5">
                {s.label}
              </div>
              {s.sub && <div className="text-[10px] text-zinc-600 font-mono-num">{s.sub}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
